<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-form-item label="改派原因:" prop="msg">
            <el-input
              v-model="form.msg"
              clearable
              type="textarea"
              autocomplete="off"
              maxlength="100"
              show-word-limit
              rows="6"
              placeholder="请输入改派原因"
            />
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { orderReassign } from "./api";
export default {
  name: "CancelOrReassignment",
  components: {
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "订单改派",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        msg: "",
        orderId: "",
        driverId: "",
      },
      rules: {
        msg: [
          {
            required: true,
            message: "请输入改派原因",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    init(orderId, driverId) {
      this.form.orderId = orderId;
      this.form.driverId = driverId;
      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          orderReassign(this.form)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("改派成功");
                this.$parent.resetTable();
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .code-image {
    width: 1.2rem;
    height: 100%;
    cursor: pointer;
    position: relative;
    right: -0.16rem;
    font-weight: 400;
    font-size: 0.14rem;
    color: #1269ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .code-image-disable {
    color: #999999;
  }
}
</style>
